import { InjectionToken } from '@angular/core';
import type { Response } from 'express';

// Shared injection token for Express Response object
// Used in SSR to set HTTP status codes and headers
export const RESPONSE = new InjectionToken<Response>('response');
